export class UploadNotRestoredError extends Error {
  constructor(
    message = "The upload hasn't been restored. The UI should've blocked the user from getting to this point.",
  ) {
    super(message);
    this.name = 'UploadNotRestoredError';
  }
}
